var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import 'babel-polyfill';
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { render } from 'react-dom';
import { ThemeProvider } from 'styled-components';
import moment from 'moment';

import { lightenColor, throwIfMissing } from './utils';
import Button from './components/button';
import Header from './components/header';
import Container from './components/container';
import ChatBot from './chat-bot';
import ChatOperator from './chat-operator';
import Survey from './survey';

var defaultTheme = {
  color: '#00A5FD',
  height: '420px',
  width: '340px',
  padding: '2.75rem',
  fontFamily: 'Helvetica Neue, sans-serif',
  robotIcon: '//www.hype.it/assets/images/robot-icon.png',
  userIcon: '//www.hype.it/assets/images/user-icon.png',
  errorIcon: '//www.hype.it/assets/images/error-icon.png',
  buttonSize: '60px'
};

var Chat = (_temp = _class = function (_Component) {
  _inherits(Chat, _Component);

  function Chat(props) {
    _classCallCheck(this, Chat);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.initialViewportMeta = document.querySelector('meta[name="viewport"]').content;

    _this.initialBodyOverflow = document.querySelector('body').style.overflow;
    _this.escFunction = _this.escFunction.bind(_this);
    _this.performHypeCheck = _this.performHypeCheck.bind(_this);
    _this.addMessage = _this.addMessage.bind(_this);
    _this.switchToChatOperator = _this.switchToChatOperator.bind(_this);

    _this.state = {
      messages: [],
      active: false,
      animateButton: false,
      open: false,
      loading: false,
      operatorChatActive: false,
      surveyActive: false,
      keywords: _this.props.keywords
    };
    return _this;
  }

  Chat.prototype.componentWillMount = function componentWillMount() {
    if (this.props.open !== this.state.open) {
      this.setState({ open: this.props.open });
    }
  };

  Chat.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
    this.performHypeCheck();
  };

  Chat.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      this.setState({ open: nextProps.open });
    }
  };

  Chat.prototype.open = function open() {
    this.setState({ open: true });
  };

  Chat.prototype.close = function close() {
    this.setState({ open: false });
  };

  Chat.prototype.toggle = function toggle() {
    this.setState({ open: !this.state.open });
  };

  Chat.prototype.performHypeCheck = function performHypeCheck() {
    var _this2 = this;

    if (!this.props.hypeCheck) {
      return this.setState({ active: true });
    }

    fetch(this.props.hypeCheck).then(function (res) {
      return res.json();
    }).then(function (json) {
      if (json.hypeNoAuthServiceList) {
        var chatBotSettings = json.hypeNoAuthServiceList.find(function (x) {
          return x.service === 'CHATBOT';
        });

        var chatOperatorSettings = json.hypeNoAuthServiceList.find(function (x) {
          return x.service === 'CHAT';
        });

        var keywords = void 0;
        if (chatOperatorSettings && chatOperatorSettings.addtInfo) {
          var serviceConfig = JSON.parse(chatOperatorSettings.addtInfo);
          keywords = serviceConfig.keywords || _this2.props.keywords;
        }

        var _checkOperatorChatSta = _this2.checkOperatorChatState(chatOperatorSettings, _this2.props.operatorChatURL, json.serverTime),
            available = _checkOperatorChatSta.available,
            availableNow = _checkOperatorChatSta.availableNow,
            availableUntil = _checkOperatorChatSta.availableUntil;

        _this2.setState({
          active: _this2.isBotChatActive(chatBotSettings),
          minConfidence: Number(chatBotSettings.addtInfo),
          operatorChatAvailable: available,
          operatorChatAvailableNow: availableNow,
          operatorChatAvailableUntil: availableUntil,
          keywords: keywords
        });
      }
    });
  };

  Chat.prototype.isBotChatActive = function isBotChatActive(settings) {
    return settings && settings.status === 'ACTIVE';
  };

  Chat.prototype.checkOperatorChatState = function checkOperatorChatState(settings, chatURL, serverTime) {
    if (!settings) return {
      available: false,
      availableNow: false
    };

    try {
      var time = moment(serverTime);
      var startTime = moment(settings.startTime, 'HH:mm').toDate();
      var endTime = moment(settings.endTime, 'HH:mm').toDate();

      var available = !!chatURL && settings && settings.status === 'ACTIVE';

      var availableNow = available && time.isAfter(startTime) && time.isBefore(endTime) && time.day() !== 6 && time.day() !== 0;

      var availableUntil = endTime;

      return {
        available: available,
        availableNow: availableNow,
        availableUntil: availableUntil
      };
    } catch (err) {
      console.error(err);
      return {
        available: false,
        availableNow: false
      };
    }
  };

  Chat.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this3 = this;

    var index = String(this.state.messages.length - 1);
    var textbox = document.getElementById('__chatbot-text-box');
    var elem = document.getElementById('__message-' + index);

    if (prevState.active === false && prevState.animateButton === false) {
      requestAnimationFrame(function () {
        _this3.setState({ animateButton: true });
      });
    }

    elem ? elem.scrollIntoView() : null;

    if (!!textbox) {
      textbox.focus();
    }
  };

  Chat.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  };

  Chat.prototype.addMessage = function addMessage(_ref) {
    var _this4 = this;

    var text = _ref.text,
        user = _ref.user,
        name = _ref.name,
        action = _ref.action,
        actions = _ref.actions,
        component = _ref.component,
        _ref$time = _ref.time,
        time = _ref$time === undefined ? Date.now() : _ref$time;

    this.setState(function (prevState) {
      actions = action ? [action] : actions;
      user = user || 'BOT';
      name = name || _this4.props.chatbotName;
      text = user === 'OPERATOR' || user === 'BOT' ? '**' + name + ':**\n\n' + text : text;

      return {
        messages: prevState.messages.concat([{ text: text, user: user, name: name, actions: actions, component: component, time: time }])
      };
    });
  };

  Chat.prototype.escFunction = function escFunction(event) {
    if (event.keyCode === 27 && this.state.open) {
      this.setState({ open: false });
    }
  };

  Chat.prototype.handleClick = function handleClick(e) {
    e.preventDefault();
    var viewportmeta = document.querySelector('meta[name="viewport"]');
    var body = document.querySelector('body');

    if (this.state.open && viewportmeta) {
      viewportmeta.content = this.initialViewportMeta;
      if (window.innerWidth <= 600) {
        body.style.overflow = this.initialBodyOverflow;
      }

      if (!!this.props.afterCloseCallback) {
        this.props.afterCloseCallback();
      }
    } else {
      viewportmeta.content = 'user-scalable=NO, width=device-width, initial-scale=1.0';
      if (window.innerWidth <= 600) {
        body.style.overflow = 'hidden';
      }
      if (!!this.props.afterOpenCallback) {
        this.props.afterOpenCallback();
      }
    }

    if (this.state.operatorChatActive) {
      this.switchToSurvey();
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  Chat.prototype.handleChatbotFail = function handleChatbotFail(failingQuestion) {
    this.setState({ active: false });
    this.props.onChatbotFail(this.state.messages.map(function (message) {
      return {
        text: message.text,
        user: message.user
      };
    }), failingQuestion);
  };

  Chat.prototype.switchToChatOperator = function switchToChatOperator(credentials) {
    this.setState({
      operatorChatActive: true,
      loading: true,
      credentials: credentials
    });
  };

  Chat.prototype.switchToSurvey = function switchToSurvey() {
    this.setState({
      operatorChatActive: false,
      surveyActive: true,
      loading: false
    });
  };

  Chat.prototype.switchToChatBot = function switchToChatBot() {
    this.setState({
      operatorChatActive: false,
      surveyActive: false,
      loading: false
    });

    this.addMessage({
      text: 'Ciao sono di nuovo Hypebot, hai altre domande per me?'
    });
  };

  Chat.prototype.render = function render() {
    if (!this.state.active) {
      return null;
    }

    var ActiveElement = void 0;
    var elementProps = void 0;
    if (this.state.operatorChatActive) {
      ActiveElement = ChatOperator;
      elementProps = _extends({
        messages: this.state.messages,
        addMessage: this.addMessage,
        switchToSurvey: this.switchToSurvey.bind(this),
        chatURL: this.props.operatorChatURL,
        chatbotName: this.props.chatbotName
      }, this.state.credentials);
    } else if (this.state.surveyActive) {
      ActiveElement = Survey;
      elementProps = {
        messages: this.state.messages,
        addMessage: this.addMessage,
        chatURL: this.props.operatorChatURL,
        switchToChatBot: this.switchToChatBot.bind(this)
      };
    } else {
      ActiveElement = ChatBot;
      elementProps = {
        messages: this.state.messages,
        addMessage: this.addMessage,
        chatbotName: this.props.chatbotName,
        endpoint: this.props.endpoint,
        subKey: this.props.subKey,
        emailAddress: this.props.emailAddress,
        minConfidence: this.props.botMinConfidence
      };

      if (this.state.operatorChatAvailable) {
        elementProps.operatorChatAvailable = this.state.operatorChatAvailable;
        elementProps.operatorChatAvailableNow = this.state.operatorChatAvailableNow;
        elementProps.operatorChatAvailableUntil = this.state.operatorChatAvailableUntil;
        elementProps.switchChat = this.switchToChatOperator;
      } else if (this.props.onChatbotFail) {
        elementProps.onChatbotFail = this.handleChatbotFail.bind(this);
        elementProps.onChatbotFailMessage = this.props.onChatbotFailMessage;
        elementProps.onChatbotFailButtonMessage = this.props.onChatbotFailButtonMessage;
      }

      if (this.state.operatorChatAvailable || this.props.onChatbotFail) {
        elementProps.keywords = this.state.keywords;
      }
    }

    var theme = _extends({}, defaultTheme, this.props.theme, {
      lightColor: lightenColor(this.props.theme.color, 0.8)
    });

    return React.createElement(
      ThemeProvider,
      { theme: theme },
      React.createElement(
        Container,
        { open: this.state.open },
        this.state.open && React.createElement(
          ActiveElement,
          elementProps,
          React.createElement(
            Header,
            {
              onClick: this.handleClick.bind(this),
              open: this.state.open
            },
            'Aiuto e Supporto'
          )
        ),
        React.createElement(Button, {
          onClick: this.handleClick.bind(this),
          open: this.state.open,
          animate: this.state.animateButton
        })
      )
    );
  };

  return Chat;
}(Component), _class.init = function (config) {
  var open = config.open,
      chatbotName = config.chatbotName,
      _config$robotIcon = config.robotIcon,
      robotIcon = _config$robotIcon === undefined ? defaultTheme.robotIcon : _config$robotIcon,
      _config$userIcon = config.userIcon,
      userIcon = _config$userIcon === undefined ? defaultTheme.userIcon : _config$userIcon,
      _config$errorIcon = config.errorIcon,
      errorIcon = _config$errorIcon === undefined ? defaultTheme.errorIcon : _config$errorIcon,
      _config$selector = config.selector,
      selector = _config$selector === undefined ? throwIfMissing('selector') : _config$selector,
      endpoint = config.endpoint,
      botMinConfidence = config.botMinConfidence,
      emailAddress = config.emailAddress,
      subKey = config.subKey,
      _config$height = config.height,
      height = _config$height === undefined ? defaultTheme.height : _config$height,
      _config$width = config.width,
      width = _config$width === undefined ? defaultTheme.width : _config$width,
      _config$padding = config.padding,
      padding = _config$padding === undefined ? defaultTheme.padding : _config$padding,
      _config$color = config.color,
      color = _config$color === undefined ? defaultTheme.color : _config$color,
      _config$fontFamily = config.fontFamily,
      fontFamily = _config$fontFamily === undefined ? defaultTheme.fontFamily : _config$fontFamily,
      _config$buttonSize = config.buttonSize,
      buttonSize = _config$buttonSize === undefined ? defaultTheme.buttonSize : _config$buttonSize,
      afterOpenCallback = config.afterOpenCallback,
      afterCloseCallback = config.afterCloseCallback,
      onChatbotFail = config.onChatbotFail,
      onChatbotFailMessage = config.onChatbotFailMessage,
      onChatbotFailButtonMessage = config.onChatbotFailButtonMessage,
      _config$keywords = config.keywords,
      keywords = _config$keywords === undefined ? [] : _config$keywords,
      __hypeCheck = config.__hypeCheck,
      operatorChatURL = config.operatorChatURL;


  var theme = {
    color: color,
    height: height,
    width: width,
    padding: padding,
    fontFamily: fontFamily,
    robotIcon: robotIcon,
    userIcon: userIcon,
    errorIcon: errorIcon,
    buttonSize: buttonSize
  };

  return render(React.createElement(Chat, {
    theme: theme,
    open: open,
    botMinConfidence: botMinConfidence,
    chatbotName: chatbotName,
    endpoint: endpoint,
    subKey: subKey,
    emailAddress: emailAddress,
    afterOpenCallback: afterOpenCallback,
    afterCloseCallback: afterCloseCallback,
    onChatbotFail: onChatbotFail,
    onChatbotFailMessage: onChatbotFailMessage,
    onChatbotFailButtonMessage: onChatbotFailButtonMessage,
    operatorChatURL: operatorChatURL,
    hypeCheck: __hypeCheck,
    keywords: keywords
  }), document.querySelector(selector));
}, _class.defaultProps = {
  open: false,
  chatbotName: 'Botty',
  botMinConfidence: 50,
  keywords: []
}, _temp);
export { Chat as default };
Chat.propTypes = process.env.NODE_ENV !== "production" ? {
  theme: PropTypes.object,
  open: PropTypes.bool,
  chatbotName: PropTypes.string,
  robotIcon: PropTypes.string,
  userIcon: PropTypes.string,
  errorIcon: PropTypes.string,
  selector: PropTypes.string,
  endpoint: PropTypes.string.isRequired,
  botMinConfidence: PropTypes.number,
  emailAddress: PropTypes.string.isRequired,
  subKey: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
  padding: PropTypes.string,
  color: PropTypes.string,
  fontFamily: PropTypes.string,
  buttonSize: PropTypes.string,
  afterOpenCallback: PropTypes.func,
  afterCloseCallback: PropTypes.func,
  onChatbotFail: PropTypes.func,
  onChatbotFailMessage: PropTypes.func,
  onChatbotFailButtonMessage: PropTypes.func,
  keywords: function keywords(props, propName, componentName) {
    if (!Array.isArray(props[propName])) {
      return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Validation failed.');
    } else {
      props[propName].forEach(function (c) {
        if (typeof c !== 'string') throw 'config error: ' + configProp + ' should contain only strings';
      });
    }
  },
  contactId: PropTypes.string,
  /*__hypeCheck is for Hype only: we call an internal service
  to see if we should display the bot and set the confidence level*/
  __hypeCheck: PropTypes.string,
  /* operatorChatURL is for Hype only: we crawl a pageto provide the operator chat*/
  operatorChatURL: PropTypes.string
} : {};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/index.js
// module id = 536
// module chunks = 1